import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=2527fd18&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=2527fd18&prod&lang=css"
import style1 from "./UploadImage.vue?vue&type=style&index=1&id=2527fd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527fd18",
  null
  
)

export default component.exports